<qaroni-counter-widget
  icon="approval_delegation"
  linkText="Ir a pendientes"
  i18n-linkText
  [count]="$count()"
  [label]="$count() | i18nPlural: pluralMapping"
  [color]="$count() ? 'accent' : 'primary'"
  (action)="goToApprovals()" />
